export enum Permission {
  PROCESS_CONFIGURATION = 'PROCESS_CONFIGURATION',
  PROCESS_EXECUTION = 'PROCESS_EXECUTION',
  PROCESS_EXECUTION_READ = 'PROCESS_EXECUTION_READ',
  BRANCH_MANAGEMENT = 'BRANCH_MANAGEMENT',
  BATCH_MANAGEMENT = 'BATCH_MANAGEMENT',
  SYSTEM_MANAGEMENT = 'SYSTEM_MANAGEMENT',
  ADMIN_PANEL = 'ADMIN_PANEL'
}
